import { Info } from 'lucide-react';
import type { SpManualTargetingKind } from '@/types/spCampaignCreate';

const OPTIONS: Array<{
  value: SpManualTargetingKind;
  label: string;
  description: string;
}> = [
  {
    value: 'KEYWORD',
    label: 'Keyword targeting',
    description: 'Choose keywords to help your products appear in shopper searches.',
  },
  {
    value: 'PRODUCT',
    label: 'Product targeting',
    description:
      'Choose specific products, categories, brands or other product features to target your ads.',
  },
];

export function ManualTargetingKindFields({
  value,
  onChange,
  disabled,
  name = 'sp-manual-targeting-kind',
}: {
  value: SpManualTargetingKind;
  onChange: (value: SpManualTargetingKind) => void;
  disabled?: boolean;
  name?: string;
}) {
  return (
    <div className="space-y-3">
      {OPTIONS.map((option) => (
        <label key={option.value} className="flex gap-3 cursor-pointer">
          <input
            type="radio"
            name={name}
            className="mt-1"
            checked={value === option.value}
            onChange={() => onChange(option.value)}
            disabled={disabled}
          />
          <span>
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground">
              {option.label}
              <Info className="h-3.5 w-3.5 text-foreground-muted" aria-hidden />
            </span>
            <span className="block text-xs text-foreground-muted mt-0.5">{option.description}</span>
          </span>
        </label>
      ))}
    </div>
  );
}
